let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6xqMO")).then(() => parcelRequire('8Qtve'));